import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { catchError } from 'rxjs/operators';
import { handleProblem } from '../problems/problem.service';

@Injectable()
export class TaskSyncReserveWithGtNetService {

  private apiUrl: string = environment.rest.apiV2Url;

  constructor(private client: HttpClient) {}

  public syncReserveWithGtNet(taskId: string): Observable<any> {
    const url = `${this.apiUrl}/tasks/${taskId}/sync-reserve-with-gtnet`;

    return this.client.post(url, {}).pipe(
      catchError(error => throwError(handleProblem(error)))
    );
  }
}
